<template>
  <svg class="oct-icon" :class="`oct-icon__${icon}`" :viewBox="`0 0 ${width} ${height}`">
    <use :xlink:href="`#oct-icon__${icon}`"></use>
  </svg>
</template>

<script>
export default {
  name: 'OctIcon',
  props: {
    /** Icon name */
    icon: {
      type: String,
      default: ''
    },
    /** Width */
    width: {
      type: Number,
      default: 20
    },
    /** Height */
    height: {
      type: Number,
      default: 20
    },
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";

.oct-icon__instagram {
  fill-rule: evenodd;
}

.oct-icon__download,
.oct-icon__drag-handle,
.oct-icon__expand-more,
.oct-icon__close,
.oct-icon__arrow-forward,
.oct-icon__arrow-back,
.oct-icon__done,
.oct-icon__share
{
  fill: none;
  stroke: #000;
  stroke-miterlimit: 1;
  stroke-width: 1.5px;
}

.oct-icon__remove,
.oct-icon__add {
  fill: none;
  stroke: #000;
  stroke-miterlimit: 1;
  stroke-width: 2px;
}
</style>
